export default "__VITE_ASSET__72wFpf6x__"